import React from 'react'
import MetricCard from '../components/(admin)/MetricCard'
import RequestOverTimeChart from '../components/(admin)/RequestOverTimeChart'
import UserFeedbackChart from '../components/(admin)/UserFeedbackChart'
import CostBreakdown from '../components/(admin)/CostBreakdown'
import ActionButtons from '../components/(admin)/ActionButtons'
import './Dashboard.css'

const Dashboard = () => {
  // Static data for metric cards
  const metricData = [
    { title: 'Total Business', value: 72, format: 'number' },
    { title: 'Total Users', value: 5440, format: 'number' },
    { title: 'Total API Calls', value: 1230000, format: 'number' },
    { title: 'LLM Monthly Cost', value: 5890, format: 'currency' }
  ]

  // Static data for Request Over Time chart
  const requestOverTimeData = [
    { date: 'May 27', value: 60 },
    { date: 'May 28', value: 80 },
    { date: 'May 29', value: 80 },
    { date: 'May 30', value: 70 },
    { date: 'May 31', value: 82 }
  ]

  // Static data for User Feedback chart
  const userFeedbackData = [
    { label: 'Positive', value: 80, color: '#10b981' },
    { label: 'Negative', value: 20, color: '#ef4444' }
  ]

  // Static data for Cost Breakdown
  const costBreakdownData = [
    { label: 'LLM', value: 4500, color: '#2563eb' },
    { label: 'Hosting', value: 3200, color: '#3b82f6' },
    { label: 'Storage', value: 1500, color: '#60a5fa' },
    { label: 'Other', value: 200, color: '#cbd5e1' }
  ]

  // Static data for Action Buttons
  const actionButtons = [
    { label: 'View Business', onClick: () => console.log('View Business clicked') },
    { label: 'Add New Business', onClick: () => console.log('Add New Business clicked') },
    { label: 'System Settings', onClick: () => console.log('System Settings clicked') }
  ]

  return (
    <div className="dashboard-container">
      <h1 className="dashboard-title">Dashboard</h1>
      
      {/* Metric Cards Row */}
      <div className="metrics-grid">
        {metricData.map((metric, index) => (
          <MetricCard
            key={index}
            title={metric.title}
            value={metric.value}
            format={metric.format}
          />
        ))}
      </div>

      {/* Charts Row */}
      <div className="charts-grid">
        {/* Request Over Time Chart */}
        <RequestOverTimeChart data={requestOverTimeData} />

        {/* User Feedback Chart */}
        <UserFeedbackChart data={userFeedbackData} />
      </div>

      {/* Bottom Row */}
      <div className="bottom-grid">
        {/* Cost Breakdown */}
        <CostBreakdown data={costBreakdownData} />

        {/* Action Buttons */}
        <div className="chart-card">
          <ActionButtons buttons={actionButtons} />
        </div>
      </div>
    </div>
  )
}

export default Dashboard
